import { flexWorkerService } from 'ogp/services';
import { useMutation } from 'react-query';

export type FlexWorkerFlexPoolsData = {
  flexWorkerId: string;
  flexPoolsToRemove: string[];
  flexPoolsToAdd: string[];
  companyId?: string;
};

export const useOgpUpdateFlexWorkerFlexPools = () => {
  const mutationFn = async (queryData: FlexWorkerFlexPoolsData) =>
    await flexWorkerService.updateFlexPoolForFlexWorker(queryData);

  return useMutation(mutationFn);
};
